import { useEffect, useState } from "react";
import { Link,useLocation,useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";
import { forgetPasswordConfirm } from "../redux/AuthCRUD";
import * as auth from "../redux/AuthRedux";
import { useDispatch } from "react-redux";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { toAbsoluteUrl } from "../../../../_jutemplate/helpers/AssetHelpers";
import "./auth.css";


//image

const initialValues = {
  newPassword: "",
  confirmPassword: "",
};

const forgotPasswordSchema = Yup.object().shape({
  newPassword: Yup.string().required("Phone number is required"),
  confirmPassword:Yup.string().oneOf([Yup.ref('newPassword'), null], 'passwords is not match').required("Confirm password is required ")
});

export function ResetPassword() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigation = useNavigate()
  const location:any = useLocation()
  const { otp,phone } = location?.state || {}; // Access passed data
  // console.log(otp+" "+phone)

  



  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values) => {
      setLoading(true);
      setTimeout(() => {
        const data = {
          new_password: values?.newPassword, 
          confirm_password: values?.confirmPassword,
          otp: otp,
          phone: phone
        }
        forgetPasswordConfirm(data).then(
          (res: any) => {
            setLoading(false);
            if (res?.data?.success === true) {
              formik.resetForm();
              navigation('/auth/login')
              toast.success(res?.data?.message, {
                position: "top-right",
                theme: "colored",
              });
            } else {
              toast(res?.data?.message, {
                 theme: "dark",
              });
            }
          },
          (err: any) => {
            setLoading(false);
            if (err?.response?.data?.success === false) {
              toast(err?.response?.data?.message, {
                theme: "dark",
              });
            }
            console.log(err);
          }
        );
      }, 100);
    },
  });

  useEffect(()=>{
    if(!otp){
      navigation('/auth')
    }
  },[])

  return (
    <>
      {/* alert */}
      <ToastContainer />

      {/* form */}
      <form
        className="form w-100"
        onSubmit={formik.handleSubmit}
        noValidate
        id="kt_login_signin_form"
      >
        {/* begin :: Heading */}
        <div className="d-flex flex-column align-items-center ">
          <img
            alt="Logo"
            src={toAbsoluteUrl("/media/logos/logo-hanay.svg")}
            // className="h-45px"
            style={{ height: "180px" }}
          />
          <h2
            className="fw-semibold m-0 mb-2"
            style={{ color: "#2F3367", fontSize: "18px" }}
          >
            Reset Password
          </h2>
          <h5
            className="fw-normal m-0"
            style={{ color: "#303468", fontSize: "18px" }}
          >
            Please! Provide Your New Password
          </h5>
        </div>

        {/* begin::Heading */}

        {/* begin::Form group */}
        <div className="fv-row mt-10">
          {/* <label className="form-label fs-6 fw-bolder text-dark">Phone Number</label> */}
          <input
            placeholder="New Password"
            type="password"
            autoComplete="off"
            {...formik.getFieldProps("newPassword")}
            className={clsx(
              "form-control form-control-lg form-control-solid rounded-2",
              { "is-invalid": formik.touched.newPassword && formik.errors.newPassword },
              {
                "is-valid": formik.touched.newPassword && !formik.errors.newPassword,
              }
            )}
           
          />
          {formik.touched.newPassword && formik.errors.newPassword && (
            <div className="fv-plugins-message-container">
              <span role="alert" className="error text-danger">
                {formik.errors.newPassword}
              </span>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className="fv-row mt-6">
          <input
            type="password"
            placeholder="Confirm Password"
            autoComplete="off"
            {...formik.getFieldProps("confirmPassword")}
            className={clsx(
              "form-control form-control-lg form-control-solid rounded-2",
              {
                "is-invalid": formik.touched.confirmPassword && formik.errors.confirmPassword,
              },
              {
                "is-valid": formik.touched.confirmPassword && !formik.errors.confirmPassword,
              }
            )}
          />
          {formik.touched.confirmPassword && formik.errors.confirmPassword && (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">
                <span role="alert" className="error text-danger">
                  {formik.errors.confirmPassword}
                </span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Action */}

        <button
          type="submit"
          id="kt_sign_in_submit"
          className="loginbtn w-100 mt-10"
          // disabled={formik.isSubmitting || !formik.isValid}
          disabled={loading ? true : false}
        >
          {!loading && <span className="indicator-label">Login</span>}
          {loading && (
            <span className="indicator-progress" style={{ display: "block" }}>
              Please wait...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>

        <div className="d-flex justify-content-end mt-5">
          <Link to="/login" className="ps-3 forgotpassword-link">
            Back to Login
          </Link>
        </div>
        {/* end::Action */}
      </form>
    </>
  );
}


